<script setup>
import { ref, onMounted } from 'vue'

// API サービス
import api from '../services/api'

// ナビゲーションバー
import NavTop from './NavTop.vue';

// 左サイドバー
import OffCanvasMenu from './OffCanvasMenu.vue';

// 右サイドバー
import OffCanvasField from './OffCanvasField.vue';

// 右サイドバー（原価管理）
import OffCanvasFieldCost from './OffCanvasFieldCost.vue';

// 右サイドバー（生育管理）
import OffCanvasFieldGrowth from './OffCanvasFieldGrowth.vue';

// マップ
import GoogleMap from './GoogleMap.vue';
const googleMapComponent = ref();

// モーダル用コンポーネント
import ModalField from "./ModalField.vue"

// 圃場データ
const fields = ref([]);
const activeField = ref(null)
const modifyField = ref(null)
const loading = ref(true)
const error = ref(null)

// GoogleMapにプロットするデータ制御用パラメータ
const mapInfo = ref({
  mapDataSW: "Off",
  mapType: "RGB",
  selectedDate: new Date().toLocaleDateString('sv-SE').replaceAll("-", "").substring(0, 8),
  openWeatherLayer: {
    cloud: false,
    precipitation: false,
    temp: false,
    wind: false,
    pressure: false,
  },
  tomorrowLayer: {
    cloudCover: false,
    precipitationIntensity: false,
    temperature: false,
    windSpeed: false,
    pressureSeaLevel: false,
  },
  seamlessMap: false,
})

onMounted(async () => {
  try {
    // DynamoDB から圃場データを取得
    const fieldsData = await api.getFields();
    // 名前の昇順でソート
    fields.value = fieldsData.sort((a, b) => a.Name.localeCompare(b.Name, 'ja'));
    loading.value = false;
  } catch (err) {
    console.error('Failed to load fields:', err);
    error.value = err.message || 'データの読み込みに失敗しました';
    loading.value = false;
  }
})

// マップ再描画処理
function reloadOverlay() {
  googleMapComponent.value.reloadOverlay();
}

// マップ上のマーカークリックイベント
function onClickMarker(field) {
  activeField.value = field;
  document.getElementById("btnCanvas").click();
}

// マップ上のマーカークリックイベント
function onClickMarkerCost(field) {
  activeField.value = field;
  document.getElementById("btnCanvasCost").click();
}

// マップ上のマーカークリックイベント
function onClickMarkerGrowth(field) {
  activeField.value = field;
  document.getElementById("btnCanvasGrowth").click();
}

// マップ中心座標移動処理
function moveMapCenter(latlng) {
  googleMapComponent.value.moveMapCenter(latlng);
}

// モーダル表示
function showModal(field) {
  modifyField.value = field;
  document.getElementById("btnModal").click();
}
</script>

<template>
  <div id="app">
    <div class="d-flex flex-column justify-content-between fullHeight">
      <!-- ナビゲーションバー -->
      <NavTop></NavTop>

      <!-- ローディング表示 -->
      <div v-if="loading" class="d-flex justify-content-center align-items-center flex-grow-1">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- エラー表示 -->
      <div v-else-if="error" class="d-flex justify-content-center align-items-center flex-grow-1">
        <div class="alert alert-danger" role="alert">
          {{ error }}
        </div>
      </div>

      <!-- マップ -->
      <GoogleMap v-else :key="mapInfo" ref="googleMapComponent" v-bind:mapInfo="mapInfo" v-bind:fields="fields" v-bind:activeField="activeField" @onClickMarker="onClickMarker" @onClickMarkerCost="onClickMarkerCost" @onClickMarkerGrowth="onClickMarkerGrowth"></GoogleMap>

      <!-- 左サイドバー -->
      <div class="offcanvas offcanvas-start w-40" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1" id="offcanvasLeft" aria-labelledby="offcanvasLeftLabel">
        <OffCanvasMenu v-bind:fields="fields" v-bind:mapInfo="mapInfo" @selectField="moveMapCenter" @showModal="showModal" @onChangeMapInfo="reloadOverlay"></OffCanvasMenu>
      </div>

      <!-- 右サイドバー -->
      <button class="btn d-none" id="btnCanvas" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Toggle right offcanvas</button>
      <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
        <OffCanvasField :key="activeField" v-bind:field="activeField"></OffCanvasField>
      </div>

      <!-- 右サイドバー（原価管理） -->
      <button class="btn d-none" id="btnCanvasCost" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasCostRight" aria-controls="offcanvasCostRight">Toggle right offcanvas</button>
      <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasCostRight" aria-labelledby="offcanvasCostRightLabel">
        <OffCanvasFieldCost :key="activeField" v-bind:field="activeField"></OffCanvasFieldCost>
      </div>

      <!-- 右サイドバー（生育管理） -->
      <button class="btn d-none" id="btnCanvasGrowth" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasGrowthRight" aria-controls="offcanvasGrowthRight">Toggle right offcanvas</button>
      <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasGrowthRight" aria-labelledby="offcanvasGrowthRightLabel">
        <OffCanvasFieldGrowth :key="activeField" v-bind:field="activeField"></OffCanvasFieldGrowth>
      </div>

      <!-- モーダルウィンドウ -->
      <button class="btn d-none" id="btnModal" type="button" data-bs-toggle="modal" data-bs-target="#modalField"></button>
      <div class="modal fade" id="modalField" tabindex="-1" ref="modalField">
        <ModalField :key="modifyField" v-bind:field="modifyField"></ModalField>
      </div>
    </div>

  </div>
</template>

<style scoped>
.fullHeight {
  height: 100vh;
}
.offcanvas-end {
  width: 35% !important;
}
@media (max-width: 767px) {
  .offcanvas-end {
    width: 100% !important;
  }
}
</style>
